import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value", "disabled", "onPaste", "onInput", "onKeydown"]
const _hoisted_2 = {
  key: 0,
  class: "v-input-segmented__error"
}

import { nextTick, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VInputSegmented',
  props: {
    length: null,
    modelValue: null,
    error: null,
    disabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose, emit }) {

const props = __props as { length: number, modelValue: string, error?: string, disabled?: boolean }



const parentRef = ref<HTMLDivElement>()

const onInput = (e: Event, i: number) => {
  const parent = parentRef.value!
  let str = ""
  for (let j = 0; j < parent.children.length; j++) {
    const child = parent.children[j] as HTMLInputElement
    if (child.value) {
      str += child.value
    }
    if (!child.value && str.length > i && j >= i) {
      child.focus()
      break
    }
  }
  
  emit("update:modelValue", str)
}

const onPaste = (e: ClipboardEvent, i: number) => {
  const text = e.clipboardData?.getData("text/plain")
  if (!text) return 

  let str = props.modelValue.slice(0, i)
  for (let j = 0; j < Math.min(4 - i, text.length); j++) {
    str += text[j]
  }
  emit("update:modelValue", str)
}

const onBackspaceDown = (e: Event, i: number) => {
  const value = (e.target as HTMLInputElement).value
  if (value === "") {
    const parent = (e.target as HTMLInputElement).parentElement!
    const lastChild = parent.children[i-1] as HTMLInputElement
    lastChild?.focus()
  }
}

const focus = () => {
  if (!parentRef.value) return
  for (let j = parentRef.value.children.length-1; j >= 0; j--) {
    const child = parentRef.value.children[j] as HTMLInputElement
    if (child.value || j === 0) {
      nextTick(() => child.focus())
      return
    }
  }
}

expose({ focus })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["v-input-segmented", { error: props.error }]),
      ref_key: "parentRef",
      ref: parentRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.length, (i) => {
        return (_openBlock(), _createElementBlock("input", {
          maxlength: "1",
          type: "text",
          pattern: "[0-9]*",
          inputmode: "numeric",
          value: props.modelValue[i-1],
          disabled: props.disabled,
          onPaste: ($event: any) => (onPaste($event, i-1)),
          onInput: ($event: any) => (onInput($event, i-1)),
          onKeydown: _withKeys(($event: any) => (onBackspaceDown($event, i-1)), ["backspace"])
        }, null, 40, _hoisted_1))
      }), 256))
    ], 2),
    (props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})